import { render, staticRenderFns } from "./default-component.vue?vue&type=template&id=5ea281d1&scoped=true&"
import script from "./default-component.vue?vue&type=script&lang=ts&"
export * from "./default-component.vue?vue&type=script&lang=ts&"
import style0 from "./default-component.vue?vue&type=style&index=0&id=5ea281d1&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea281d1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCard } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAutocomplete,VCard,VForm,VTextField,VTextarea})
